<template lang="pug">
  .thumb.thumb--profile(:class="{'active':active}" @mouseenter='hovered' @mouseleave='unhovered')
    a(:href="practitionerUrl")
      span.clickable-card
    .avatar-certify
      .avatar
        img.img-fluid(:alt="profilePictureAlt" :src="avatarUrl")
      .fal.fa-trophy-alt.badge-certify.badge-certify-left(v-if="expertiseLevel >= 2" title="Ostéopathe plébiscité par les patients")
      .fal.fa-thumbs-up.badge-certify.badge-certify-center(v-if="expertiseLevel == 3" title="Ostéopathe expérimenté")
      .fal.fa-shield-check.badge-certify(title="Ostéopathe agréé et certifié par REFLEX OSTEO")
    .thumb__content
      a.thumb__title(:href="practitionerUrl")
        p.h4 {{ nameFormatted }}
      .info-icon
        span.fal.fa-map-marker-alt
        .city
          div(v-if="officeName") Cabinet {{ officeName }}
          div {{ location }}
      .info-icon
        span.fal.fa-location-arrow
        .city
          span Ostéopathe à
          span {{ distance }}
      .info-icon(v-if="reviewCount")
        span.review-count {{ reviewCount }}
        .city
          span {{ pluralizedReviews }}


      .thumb__action
        next-availability-btn(:practitioner="result")
      a.underline(:href="practitionerUrl") {{ $t('components.result_card.see_more') }}

</template>

<script>
import { get } from "lodash"
import NextAvailabilityBtn from "@appComponents/NextAvailabilityBtn"

export default {
  components: { NextAvailabilityBtn },
  props: {
    result: Object,
    active: Boolean,
    officeId: Number,
    officeName: String,
    officeAddress: Object,
    distance: String
  },
  data () {
    return {
      id: this.result.id,
      nameFormatted: this.result.attributes.full_name_formatted,
      url: this.result.attributes.url,
      contractType: this.result.attributes.contract_type_translated,
      avatarUrl: this.result.attributes.avatar_url,
      reviewCount: this.result.attributes.reviews_count,
      expertiseLevel: this.result.attributes.expertise_level
    }
  },
  methods: {
    hovered () {
      this.$emit('hover')
    },
    unhovered () {
      this.$emit('unhover')
    }
  },
  computed: {
    practitionerUrl () {
      if (this.officeId) {
        return `${this.url}?office_id=${this.officeId}`
      } else {
        return this.url
      }
    },

    location () {
      let defaultValue = this.result.attributes.address.attributes.city_with_postal_code

      return get(this.officeAddress, 'attributes.city_with_postal_code', defaultValue)
    },

    profilePictureAlt () {
      let alt = ""

      alt = alt + `${this.result.attributes.full_name} ostéopathe`

      if (this.result.attributes.address) {
        alt = alt + ` à ${this.result.attributes.address.attributes.city}`
      }

      return alt
    },

    pluralizedReviews () {
      return `Avis patient${this.reviewCount > 1 ? "s" : ""}`
    }
  }
}
</script>
